import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { portalApi } from '../../../../lib/portalApi';

export default function AdminOverviewPage() {
  const [stats, setStats] = useState({ apps: 0, onboarding: 0, batches: 0, startups: 0 });

  useEffect(() => {
    Promise.all([
      portalApi.listApplications().catch(() => []),
      portalApi.onboardingQueue().catch(() => []),
      portalApi.listBatches().catch(() => []),
      portalApi.listStartups().catch(() => []),
    ]).then(([apps, queue, batches, startups]) => {
      setStats({
        apps: apps.filter((a) => ['pending', 'under_review'].includes(a.status)).length,
        onboarding: queue.length,
        batches: batches.length,
        startups: startups.length,
      });
    });
  }, []);

  const cards = [
    { label: 'Open applications', value: stats.apps, to: '/admin/applications' },
    { label: 'In onboarding', value: stats.onboarding, to: '/admin/onboarding' },
    { label: 'Batches', value: stats.batches, to: '/admin/batches' },
    { label: 'Startups', value: stats.startups, to: '/admin/startups' },
  ];

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-semibold text-white">Overview</h1>
        <p className="text-white/50 mt-1">Apply → review → onboard → batch.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => (
          <Link
            key={c.to}
            to={c.to}
            className="rounded-2xl border border-white/10 bg-white/[0.03] p-5 hover:border-[#d42b92]/40 transition"
          >
            <div className="text-3xl font-semibold text-white">{c.value}</div>
            <div className="text-sm text-white/50 mt-1">{c.label}</div>
          </Link>
        ))}
      </div>
      <div className="flex flex-wrap gap-3">
        <Link to="/admin/applications" className="px-4 py-2 rounded-xl bg-[#d42b92] text-white text-sm">
          Review applications
        </Link>
        <Link to="/admin/onboarding" className="px-4 py-2 rounded-xl border border-white/15 text-white text-sm">
          Onboarding board
        </Link>
        <Link to="/admin/questionnaire" className="px-4 py-2 rounded-xl border border-white/15 text-white text-sm">
          Edit apply form
        </Link>
      </div>
    </div>
  );
}
